var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelCatalogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8775 17.3782H8.8775C7.87 17.3782 7.36625 17.3782 6.95241 17.4887C6.40133 17.6364 5.89887 17.9267 5.49552 18.3302C5.09218 18.7338 4.80217 19.2364 4.65466 19.7875",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.988 7.62809H17.6547M8.988 11.4198H14.4047M11.1547 23.8781C8.091 23.8781 6.55808 23.8781 5.60691 22.9258C4.65466 21.9747 4.65466 20.4418 4.65466 17.3781V8.71143C4.65466 5.64776 4.65466 4.11484 5.60691 3.16368C6.55808 2.21143 8.091 2.21143 11.1547 2.21143H15.488C18.5517 2.21143 20.0846 2.21143 21.0357 3.16368C21.988 4.11484 21.988 5.64776 21.988 8.71143M15.488 23.8781C18.5517 23.8781 20.0846 23.8781 21.0357 22.9258C21.988 21.9747 21.988 20.4418 21.988 17.3781V13.0448",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelCatalogIcon);
export default __webpack_public_path__ + "static/media/labelCatalog-icon.0ef3fb9a3c1d080313328dca8bb79d31.svg";
export { ForwardRef as ReactComponent };